import React from 'react'
import ReactOnRails from "react-on-rails/client";

import YourReservationBlue from 'frontend/RentalCars/YourReservationBlue'
import LanguageSelect from 'frontend/Navigation/LanguageSelect'
import PopularLocations from 'frontend/Navigation/PopularLocations'
import Cookies from 'frontend/Navigation/Cookies'
import SeoCarClasses from 'frontend/Navigation/SeoCarClasses'
import SeoProviderReviews from 'frontend/Navigation/SeoProviderReviews'
import MobileMenu from 'frontend/Navigation/MobileMenu'
import SeoFaq from 'frontend/Navigation/SeoFaq'
import SeoSearchModal from 'frontend/Navigation/SeoSearchModal'

ReactOnRails.register({YourReservationBlue, LanguageSelect, PopularLocations, Cookies, 
  SeoCarClasses, SeoProviderReviews, MobileMenu, SeoFaq, SeoSearchModal})